{
  "version": 1,
  "asset_id": "e7d5418f-ed5a-45e7-b798-83de68e63fb3",
  "project_id": "ce1b172f-33a4-453d-acfe-2d9320f3bb26",
  "url": "/__l5e/assets-v1/e7d5418f-ed5a-45e7-b798-83de68e63fb3/menorah-official.png",
  "r2_key": "a/v1/ce1b172f-33a4-453d-acfe-2d9320f3bb26/e7d5418f-ed5a-45e7-b798-83de68e63fb3/menorah-official.png",
  "original_filename": "menorah-official.png",
  "size": 16044,
  "content_type": "image/png",
  "created_at": "2026-07-18T20:16:08Z"
}
